import { device } from '@accedo/xdk-core';

const checkLegacyDevice = () => {
  const { platform } = device;
  document.documentElement.setAttribute('data-device', `${platform}`);
};

export default checkLegacyDevice;
